import { getFeatureConfig } from '@luna/feature-config';

import { isDefined, transformOldContactToNew } from './ContactAdapterService';
import type { NewStructureContact, OldStructureContact } from './ContactAdapterTypes';
import { ContactListFlag } from './ContactDataManagementTypes';

const isUsingLegacyApi = (): boolean =>
    getFeatureConfig(
        ({ contactDataManagement }) => contactDataManagement.legacy.useLegacyApiOnlyForViewContacts,
    );

const isContactNewStructureArray = (
    contacts: NewStructureContact[] | OldStructureContact[],
): contacts is NewStructureContact[] => {
    return !isUsingLegacyApi();
};

export const transformContactsToNewStructure = (
    contacts: NewStructureContact[] | OldStructureContact[],
): NewStructureContact[] => {
    if (isContactNewStructureArray(contacts)) {
        return contacts;
    }

    return contacts.map(transformOldContactToNew).filter(isDefined);
};

const ALL_NOT_ALLOWED_ADD_CONTACT_LIST_FLAGS = [
    ContactListFlag.ADDRESS_NOT_ALLOWED,
    ContactListFlag.PHONE_NOT_ALLOWED,
    ContactListFlag.EMAIL_NOT_ALLOWED,
    ContactListFlag.MOBILE_PHONE_NOT_ALLOWED,
    ContactListFlag.LANDLINE_PHONE_NOT_ALLOWED,
];
export const getContactListFlags = (flags: ContactListFlag[] | undefined): ContactListFlag[] => {
    if (isUsingLegacyApi()) {
        return ALL_NOT_ALLOWED_ADD_CONTACT_LIST_FLAGS;
    }

    return flags ?? [];
};
